export default __webpack_public_path__ + "static/media/auth-character-right.535ee6fe.png";